/**
 * used to format strings into zip9
 * @param {String} zipcode
 * @return {String}
 */
export const formatZip9 = (zipcode) => {
  if (!zipcode) return '';

  const [one, two, three, four, five, ...tail] = zipcode.split('');
  const zip5 = [one, two, three, four, five].join('');
  return tail.length ? [zip5, '-', ...tail].join('') : zip5;
};
